<template>
    <div class="pt10 pb10 pl10 pr10">
        <h4>下载模板</h4>
        <p class="mt10 mb10">为提高导入的成功率,请下载并使用系统提供的模板</p>
        <el-button type="primary" @click="download">下载模板</el-button>

        <h4 class="mt20">上传文件</h4>
        <el-form
            :model="FormData"
            ref="FormData"
            class="demo-ruleForm">
            <el-form-item>
                <el-upload
                        style="margin-top: 10px"
                        class="upload-demo"
                        :headers="imHeader"
                        :data="uploadData"
                        :file-list="arrFile"
                        drag
                        action="/hallportal/admin/excel/import"
                        :disabled="hasExistFile"
                        type="drag"
                        :before-upload="handleBeforeUpload"
                        :on-success="handleSuccess"
                        accept=".xls,.xlsx"
                        :format="standardFileState.formatFileType"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或
                        <em v-if="arrFile.length<1">点击上传</em>
                        <span v-else>点击上传</span>
                    </div>
                    <div class="el-upload__tip" slot="tip">可上传.xls,.xlsx,格式文件，且不超过10MB
                    </div>
                    <div style="color: red;" class="el-upload__tip" slot="tip">
                        注意：文件必上传，一次只能上传一个文件
                    </div>
                </el-upload>
            </el-form-item>
        </el-form>
            <div>
            <span style="color: red">{{proName}}</span>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    export default {
        props: {
            uplodData: {
                type: Object,
                required: true
            },
            downloadType: {
                type: String,
                required: true
            }
        },
        name: "uplodModal",
        data() {
            return {
                btnState: true,
                FormData: {
                    dimYear: moment(new Date()).format("YYYY")
                },
                proName: "",
                maxUploadFileSize: 10 * 1024 * 1024,
                hasExistFile: false,
                standardFileState: {
                    state: true,
                    formatFileType: ["xls", "xlsx"],
                },
                arrFile: [],
                uploadData:{
                    type:'',
                    dimYear:null,
                    file:null,
                }
            }
        },
        created(){
            let token = window.sessionStorage.getItem('nz_access_token');
            this.imHeader = { 'Authorization': token};
        },
        methods: {
            handleBeforeUpload(file) {
                this.uploadData.dimYear = new Date(this.FormData.dimYear).getFullYear();
                this.uploadData.type = this.uplodData.type;

                if(this.uplodData.type === 'teacher'){
                    this.uploadData['majorId'] = this.uplodData.majorId
                }
                this.hasExistFile = true
                if (file.size > this.maxUploadFileSize) {
                    this.$message.error("上传文件最大不能超过10M，请检查文件上传大小！");
                    return false;
                }
                let extname = file.name.substr(file.name.lastIndexOf(".") + 1, file.name.length - file.name.lastIndexOf("."));
                let foundext = false;
                this.standardFileState.formatFileType.forEach(e => {
                    if (e == extname) {
                        foundext = true;
                    }
                });
                if (!foundext) {
                    this.$message.error("上传的文件类型非指定的文件类型，请选择指定的文件类型");
                    return false;
                }
                this.uploadData.file = file;
            },
            handleSuccess(response, file, fileList) {
                console.log()
                if (response.code == 0) {
                    this.$message({
                        message: "上传成功",
                        type: "success"
                    });
                    this.$emit("successCallBack")
                    this.reset();

                } else {
                    this.proName = '文件上传失败：失败原因：' + response.msg
                }
                this.btnState = false;
            },
            reset() {
                this.proName = "";
                this.hasExistFile = false;
                this.FormData.dimYear = moment(new Date()).format("YYYY")
                this.btnState = true;
                this.arrFile = []
            },

            download(){
                this.$DownLoad(
                    "/admin/excel/download?type="+this.downloadType,
                    null,
                    res => {
                        if (res.status == 200) {
                            // this.$message.success("开始下载");
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },
        }
    }
</script>

<style scoped>
.demo-ruleForm /deep/ .el-upload--text {
    width: 100%;
    height: 150px;
}
</style>
